import React, { useState } from "react";
import { Box, Flex, getAnimation, PositionedFlex } from "../../assets/ui";
import { LogoLoader } from "../../assets/icons";
///////////////////////////////////////////////////////////////////////////////////////////////////

export const Loader = ({ isLoading }) => {
  const [visible, setVisible] = useState(false);
  if (isLoading && !visible) {
    setVisible(true);
  }
  if (!isLoading && visible) {
    setTimeout(() => setVisible(false), 1000);
  }
  if (!visible) {
    return null;
  }
  return (
    <PositionedFlex
      top="0"
      bottom="0"
      zIndex={6}
      width="100vw"
      height="100vh"
      position="fixed"
      bg="rgba(0, 0, 0, 0.6)"
      transition="opacity 0.5s"
      opacity={isLoading ? 1 : 0}
    >
      <Flex width="100%" alignItems="center" justifyContent="center">
        <Box
          additionalStyles={getAnimation({
            animationName: "spin",
            animationProps: "3s infinite ease"
          })}
        >
          <LogoLoader />
        </Box>
      </Flex>
    </PositionedFlex>
  );
};

export default Loader;
